module.exports = __webpack_public_path__ + "img/1532702897.487eb455.jpg";